const EndpointTime = (()=>{

    const _EndpointTimeConfig = ()=>{
        const sticky = document.querySelector('.stikcy-time');
        const stickyDirect = document.querySelector('#direct');
        const stickyToStart = document.querySelector('#time-to-start');
        const stickyFinished = document.querySelector('#finished');
        const stickyTime = document.querySelector('#dinamic-time');
        const triviaPages = document.querySelector('#trivia-pages');

        const checkTriviaTime = () => {
            const requestOptions = {
                method: "GET",
                redirect: "follow"
            };
        
            fetch("/check-time", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    const { left_time_to_start, error } = result;
                    if(sticky){
                        result.error !== 'Access denied' && sticky.classList.add('active');
                        if (result.hasOwnProperty("left_time_to_start")) {
                            stickyToStart.classList.add('active');
                            stickyDirect.classList.remove('active');
                            stickyFinished.classList.remove('active');
                            stickyTime.textContent = left_time_to_start;
                        }
                        else if (result.hasOwnProperty("time_to_end")) {
                            stickyToStart.classList.remove('active');
                            stickyFinished.classList.remove('active');
                            stickyDirect.classList.add('active');
                        }
                        else if (result.hasOwnProperty("too_late")) {
                            stickyToStart.classList.remove('active');
                            stickyDirect.classList.remove('active');
                            stickyFinished.classList.add('active');
                        }
                    }
                    //Remove questions
                    error && localStorage.removeItem('questions');
                    error && localStorage.removeItem('categorie-enable');
                    //Execute 
                    setTimeout(() => {
                        checkTriviaTime();
                    }, 1000);
                })
                .catch((error) => console.error(error));
        }
        if(sticky || triviaPages){
            !document.querySelector('#trivia-questions') ? checkTriviaTime() : stickyToStart.remove();
        }
    }

    /*
    *Return child functions in a objects
    */
    return{
        setHandleEvent: function(){
            try { _EndpointTimeConfig(); } catch (error) { }
        }
    }
})();

/*
*Load global functions
*/
const loadEndpointTimeHandlers = ()=>{
    EndpointTime.setHandleEvent();
}

export { loadEndpointTimeHandlers }